import { useEffect } from 'react';
import { useParams } from 'react-router';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingCalendar = () => {
  const params = useParams();
  const { response: calendar, onFetch } = useFetch('calendar', Api.CALENDAR);

  const onFetchCalendar = () => onFetch({ pathParams: { id: params.id } });

  useEffect(() => {
    if (params.id) onFetchCalendar();
  }, [params]);

  return {
    calendar,
    onFetchCalendar,
  };
};

export default useGettingCalendar;
